import {PdfMeta, PdfSection} from './pdfTypes';

// Render the PDF on the main thread, but load the heavy @react-pdf/renderer bundle
// LAZILY (dynamic import) so it never bloats the main app bundle — it's fetched once
// on the first export, then cached. (An earlier Web Worker attempt was reverted: in
// this CRA/webpack setup react-pdf did not return from the worker, so every export
// stalled for the full worker timeout before falling back. Main-thread render is the
// fast path here.)
export const generatePdf = async (title: string, sections: PdfSection[], meta: PdfMeta): Promise<Blob> => {
    const {buildPdfBlob} = await import('./pdfExport');
    return buildPdfBlob(title, sections, meta);
};
